import React from 'react'

const StatusBadge = (props) => {
  const {
    title,
    customStyle
  } = props

  const style = {
    display: "flex",
    padding: "8px 24px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    flex: "1 0 0",
    alignSelf: "stretch",
    whiteSpace: "nowrap",
    borderRadius: "4px",
    maxWidth: 'inherit',
    ...customStyle
  }

  return (
    <div style={style}>{title}</div>
  )
}

export default StatusBadge